import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import { EnquiryProvider } from "@/context/EnquiryContext";
import Header from "@/components/Header";
import LeadPopup from "@/components/LeadPopup";
import EnquiryModal from "@/components/EnquiryModal";
import FloatingConsult from "@/components/FloatingConsult";
import WhatsAppButton from "@/components/WhatsAppButton";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import ModularKitchens from "@/pages/ModularKitchens";
import Wardrobes from "@/pages/Wardrobes";
import Storage from "@/pages/Storage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  useLenis();
  return (
    <>
      <ScrollToTop />
      <Header />
      <LeadPopup />
      <EnquiryModal />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/modular-kitchens" element={<ModularKitchens />} />
        <Route path="/wardrobes" element={<Wardrobes />} />
        <Route path="/storage" element={<Storage />} />
      </Routes>
      <Footer />
      <FloatingConsult />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <EnquiryProvider>
          <Layout />
        </EnquiryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
